// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { EntityDiagram_EntityDiagramFragment } from './EntityDiagram.generated';
import { GetTaxStatusForEntity_EntityFragment } from '../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import { gql } from '@apollo/client';
import { EntityDiagram_EntityDiagramFragmentDoc } from './EntityDiagram.generated';
import { GetTaxStatusForEntity_EntityFragmentDoc } from '../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OwnershipDiagram_EntityFragment = (
  { __typename?: 'Entity', id: string, extendedDisplayKind: string, stage: Types.EntityStage, entityKind: Types.EntityKind, household: { __typename?: 'Household', id: string }, entityDiagrams: { __typename?: 'EntityDiagramConnection', edges?: Array<{ __typename?: 'EntityDiagramEdge', node?: (
        { __typename?: 'EntityDiagram' }
        & EntityDiagram_EntityDiagramFragment
      ) | null } | null> | null }, ownedByStakes?: Array<{ __typename?: 'OwnershipStake', id: string, ownershipPercentage?: Percent | null, owningIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, owningEntity?: (
      { __typename?: 'Entity', id: string, extendedDisplayKind: string, entityKind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }
      & GetTaxStatusForEntity_EntityFragment
    ) | null }> | null, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }
  & GetTaxStatusForEntity_EntityFragment
);

export type OwnershipDiagramQueryVariables = Types.Exact<{
  entityWhere: Types.EntityWhereInput;
}>;


export type OwnershipDiagramQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & OwnershipDiagram_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    OwnershipDiagram: 'OwnershipDiagram' as const
  },
  Fragment: {
    OwnershipDiagram_Entity: 'OwnershipDiagram_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const OwnershipDiagram_EntityFragmentDoc = gql`
    fragment OwnershipDiagram_Entity on Entity {
  id
  entityKind: kind
  extendedDisplayKind
  stage
  household {
    id
  }
  entityDiagrams(where: {kind: OWNERSHIP}) {
    edges {
      node {
        ...EntityDiagram_EntityDiagram
      }
    }
  }
  ownedByStakes {
    id
    ownershipPercentage
    owningIndividual {
      id
      displayName
    }
    owningEntity {
      id
      entityKind: kind
      extendedDisplayKind
      subtype {
        id
        displayName
      }
      ...GetTaxStatusForEntity_Entity
    }
  }
  subtype {
    id
    displayName
  }
  ...GetTaxStatusForEntity_Entity
}
    ${EntityDiagram_EntityDiagramFragmentDoc}
${GetTaxStatusForEntity_EntityFragmentDoc}`;
export const OwnershipDiagramDocument = gql`
    query OwnershipDiagram($entityWhere: EntityWhereInput!) {
  entities(where: $entityWhere) {
    edges {
      node {
        ...OwnershipDiagram_Entity
      }
    }
  }
}
    ${OwnershipDiagram_EntityFragmentDoc}`;

/**
 * __useOwnershipDiagramQuery__
 *
 * To run a query within a React component, call `useOwnershipDiagramQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnershipDiagramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnershipDiagramQuery({
 *   variables: {
 *      entityWhere: // value for 'entityWhere'
 *   },
 * });
 */
export function useOwnershipDiagramQuery(baseOptions: Apollo.QueryHookOptions<OwnershipDiagramQuery, OwnershipDiagramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OwnershipDiagramQuery, OwnershipDiagramQueryVariables>(OwnershipDiagramDocument, withFetchPolicyContext(options));
      }
export function useOwnershipDiagramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnershipDiagramQuery, OwnershipDiagramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OwnershipDiagramQuery, OwnershipDiagramQueryVariables>(OwnershipDiagramDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useOwnershipDiagramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OwnershipDiagramQuery, OwnershipDiagramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OwnershipDiagramQuery, OwnershipDiagramQueryVariables>(OwnershipDiagramDocument, withFetchPolicyContext(options));
        }
export type OwnershipDiagramQueryHookResult = ReturnType<typeof useOwnershipDiagramQuery>;
export type OwnershipDiagramLazyQueryHookResult = ReturnType<typeof useOwnershipDiagramLazyQuery>;
export type OwnershipDiagramSuspenseQueryHookResult = ReturnType<typeof useOwnershipDiagramSuspenseQuery>;
export type OwnershipDiagramQueryResult = Apollo.QueryResult<OwnershipDiagramQuery, OwnershipDiagramQueryVariables>;